import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PageProjectsItemComponent } from './page.projects.item/page.projects.item.component';
import { PageAccountComponent } from './page.account/page.account.component';
import { PageProjectsGroupComponent } from './page.projects.group/page.projects.group.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageProjectsParticipatingGroupComponent } from './page.projects.participating.group/page.projects.participating.group.component';
import { PageProjectsFilebrowserComponent } from './page.projects.filebrowser/page.projects.filebrowser.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageProjectsMineGroupComponent } from './page.projects.mine.group/page.projects.mine.group.component';
import { ComponentUserActivityDashboardComponent } from './component.user.activity.dashboard/component.user.activity.dashboard.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageProjectsComponent } from './page.projects/page.projects.component';
import { ComponentReviewModalComponent } from './component.review.modal/component.review.modal.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageProjectsParticipatingComponent } from './page.projects.participating/page.projects.participating.component';
import { PageReviewsComponent } from './page.reviews/page.reviews.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { ComponentProjectFileActionsComponent } from './component.project.file.actions/component.project.file.actions.component';
import { PageProjectsMineComponent } from './page.projects.mine/page.projects.mine.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ReviewOpsWorkspaceRouteReuseStrategy } from './workspace-tabs';
import { ReviewOpsWorkspaceKeepaliveOutletComponent } from './workspace-keepalive-outlet';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        ReviewOpsWorkspaceKeepaliveOutletComponent,
        AppComponent,
        PageAdminComponent,
        PageProjectsItemComponent,
        PageAccountComponent,
        PageProjectsGroupComponent,
        PortalSeasonPaginationComponent,
        PageProjectsParticipatingGroupComponent,
        PageProjectsFilebrowserComponent,
        LayoutEmptyComponent,
        PageProjectsMineGroupComponent,
        ComponentUserActivityDashboardComponent,
        PortalSeasonTreeComponent,
        PageLoginComponent,
        ComponentNavSidebarComponent,
        PortalSeasonFormDropdownComponent,
        PortalSeasonLoadingDefaultComponent,
        PageProjectsComponent,
        ComponentReviewModalComponent,
        LayoutSidebarComponent,
        PageProjectsParticipatingComponent,
        PageReviewsComponent,
        PortalSeasonModalComponent,
        ComponentProjectFileActionsComponent,
        PageProjectsMineComponent,
        PortalSeasonLoadingSeasonComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: true
        },
        {
            provide: RouteReuseStrategy,
            useClass: ReviewOpsWorkspaceRouteReuseStrategy
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
